<template>
  <div>
    <!-- <div class="heading"></div> -->
    <div id="sidebar-desktop">
      <div class="filter-title">FILTERS</div>
      <Filters></Filters>
    </div>
  </div>
</template>

<script>
import Filters from "@/components/Filters.vue";

export default {
  name: "sidebar-desktop",
  components: {
    Filters,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";
@import "@/assets/styles/variables.scss";

#sidebar-desktop {
  padding: 40px;
  width: 100%;
  min-height: 500px;
  background: #FFFFFF;
/* color/sys/light/accent/primary/neutral/default

ref: color.ref.amber.500
*/
border-top: 4px solid #BE7D2D;
/* /CardShadow/Default */

box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
border-radius: 12px;
}

.filter-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  letter-spacing: 0.2em;
  text-transform: uppercase;

  /* color/sys/light/text/lvl-1 */

  color: #30384a;
}

.heading {
  background: $cobaltBlue;
  color: white;
  height: 25px;
  font-weight: bold;
  margin-bottom: 0;
  text-align: center;
  padding: 0.75em;
  text-transform: none !important;
}

.tool-bar__order-by {
  background: $light;
  width: 100%;
  cursor: pointer;
  padding: 0.3em;
  margin-bottom: 0.75em;
  text-align: center;
  border: solid 1px #919191;
  border-radius: 8px;
}
.order-dropdown {
  position: absolute;
  width: 158px;
  margin-top: 8px;
  z-index: 102;
  margin-left: -6px !important;
  border: solid 1px #919191;
  border-radius: 3px;
  background: white;
  * + * {
    border-top: 1px dashed $primary-dark;
  }
  .order-dropdown-item {
    padding: 0.6em 0.3em;
    margin: 0;
    cursor: pointer;
  }
  .order-dropdown-item:hover {
    background: $secondary-color;
  }
}
</style>